import React from 'react';

import { TrialEndedModal } from './TrialEndedModal';
import TrialStartedModal from './TrialStartedModal';
import WidgetsTour from './Walkthrough';
import FeedbackChurnModal from './FeedbackChurnModal';
import NotEnoughFeaturesModal from './NotEnoughFeaturesModal';
import DiscountModal from './DiscountModal';
import ExtendTrialModal from './ExtendTrialModal';
import MidTrialModal from './MidTrialModal';

function AllTheModals() {
  return (
    <>
      <TrialEndedModal />
      <TrialStartedModal />
      <WidgetsTour />
      <FeedbackChurnModal />
      <NotEnoughFeaturesModal />
      <DiscountModal />
      <ExtendTrialModal />
      <MidTrialModal />
    </>
  );
}

export default AllTheModals;
